<template>
  <v-dialog max-width="1000"
            scrollable
            v-model="dialog">

    <v-card>
      <v-card-title>
        Réponses
        <v-spacer/>
        <v-icon @click="dialog=false">mdi-close</v-icon>
      </v-card-title>
      <v-divider/>

      <v-card-text class="pa-8 dialog-scroll-target">


        <v-card
            outlined
            class="rounded-lg mb-3"
            v-if="investigation.investigation?.use_grading_criteria"
        >

          <v-card-text>
            <h4 class="grey--text text--darken-3">
              SKUs & Critères de notation
            </h4>
          </v-card-text>

          <v-divider/>

          <v-card-text>
            <v-switch color="success"
                      v-if="['pending', 'temp'].includes(status)"
                      label="Existe SKUs ?"
                      v-model="is_required_skus"
            />
            <v-select :error-messages="errors.skus"
                      :items="investigation.investigation.skus"
                      :disabled="!['pending', 'temp'].includes(status)"
                      outlined
                      dense
                      v-model="skus"
                      :label="is_required_skus ? 'SKUs à vérifier (obligatoires)' : 'SKUs à vérifier (optionnels)'"
                      item-value="id"
                      item-text="sku"
                      multiple
                      chips
                      class="custom-chip"
                      deletable-chips
                      hint="Sélectionnez les SKUs dont la présence sera vérifiée lors de cette tâche."
                      persistent-hint
            />
          </v-card-text>

          <v-card-text class="pa-0">

            <v-simple-table v-if="investigation.investigation?.use_grading_criteria">
              <thead>
              <tr>
                <th>Critère</th>
                <th width="100">Note</th>
                <th width="200">Résultat</th>
              </tr>
              </thead>

              <tbody>
              <tr
                  v-for="rule in investigation.investigation.grading_rules"
                  :key="rule.id"
              >
                <td>{{ rule.rule }}</td>

                <td class="font-weight-bold">
                  {{ rule.note }}
                </td>

                <td>
                  <v-btn-toggle
                      :class="!['pending', 'temp'].includes(status) ? 'v-btn--disabled'  : ''"
                      v-model="rule.status"
                      mandatory
                      dense
                      rounded
                  >
                    <v-btn value="conform" small color="success" :text="rule.status !== 'conform'"
                    >
                      <v-icon left color="white" dense v-if="rule.status === 'conform'">mdi-check</v-icon>
                      <span class="font-weight-bold"
                            :class="rule.status === 'conform' ?'white--text' : ''">Conforme</span>
                    </v-btn>

                    <v-btn value="non_conform" small color="error" :text="rule.status !== 'non_conform'"
                    >
                      <v-icon left color="white" dense v-if="rule.status === 'non_conform'">mdi-close</v-icon>
                      <span class="font-weight-bold"
                            :class="rule.status === 'non_conform' ?'white--text' : ''"> Non conforme</span>
                    </v-btn>

                  </v-btn-toggle>
                </td>
              </tr>
              </tbody>
            </v-simple-table>

            <v-textarea v-model="remark"
                        v-if="!isValidated"
                        rows="3"
                        clearable
                        class="mx-5 mt-3"
                        filled
                        hint="Cette remarque sera visible par l'utilisateur en cas de refus."
                        persistent-hint
                        placeholder="Ajouter une remarque..."></v-textarea>

            <v-alert
                v-if="investigation.investigation?.use_grading_criteria"
                :type="isValidated ? 'success' : 'warning'"
                dense
                class="mx-5 mt-3"
            >
              <div v-if="isValidated">
                Cette tâche sera <strong>validée</strong> (au moins un critère à points est conforme).
              </div>
              <div v-else>
                Cette tâche sera <strong>refusée</strong> (aucun critère à points n'est conforme).
              </div>
            </v-alert>

            <v-alert
                text
                color="grey"
                class="mt-3 mx-5"
            >
              <div class="d-flex align-center justify-space-between">
                <div>
                  <strong class="gifty-text d-block">
                    Note totale : {{ totalScore }}
                  </strong>

                  <small class="grey--text mt-1">
                    Seules les tâches marquées “Conforme” sont comptabilisées dans le calcul de la note.
                  </small>
                </div>

                <v-btn color="success"
                       :disabled="!!(!['pending', 'temp'].includes(status))"
                       depressed dark class="rounded-lg" @click="save" :loading="btnLoading">
                  <v-icon left>mdi-content-save-outline</v-icon>
                  {{ status === 'temp' ? 'Mettre à jour' : 'Valider' }}
                </v-btn>
              </div>
            </v-alert>

          </v-card-text>

        </v-card>


        <v-card outlined class="rounded-lg mb-3" v-for="(response,i) in investigation.responses" :key="i">

          <v-card-text>
            <v-chip text-color="gifty"
                    label
                    class="bg-subtle-gifty"
            >
              Tâche N° : {{ i + 1 }}
            </v-chip>
          </v-card-text>

          <v-divider/>

          <v-card-text class="grey lighten-5">
            <v-row>
              <v-col cols="6" class="d-flex align-center">
                <v-icon class="mr-2">mdi-book-open</v-icon>
                <h4 class="grey--text text--darken-3">Intitulé</h4>
              </v-col>
              <v-col cols="6" class="d-flex align-center">
                <v-icon class="mr-2">mdi-message-reply-text</v-icon>
                <h4 class="grey--text text--darken-3">Réponse</h4>
              </v-col>
            </v-row>
          </v-card-text>


          <v-divider/>

          <v-card-text>
            <v-row>

              <v-col cols="6">
                <p>
                  {{ response.task.question.fr }}
                </p>
                <div v-if="response.task.question_type.key === 'image'">
                  <v-row>
                    <v-col cols="3">
                      <v-img width="100%"
                             height="100%"
                             @click="[lightboxImage = [{src: FILE_URL + response.task.file}],visible = true]"
                             class="rounded-lg grey lighten-4 cursor-zoom"
                             :src="FILE_URL + response.task.file"></v-img>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="response.task.question_type.key === 'multiple_images'">
                  <v-row>
                    <v-col cols="3" v-for="(image,imgIndex) in response.task.files" :key="imgIndex">
                      <v-img v-if="image"
                             width="100%"
                             height="100%"
                             @click="showLightbox(imgIndex,response.task.files)"
                             class="rounded-lg grey lighten-4 cursor-zoom"
                             :src="FILE_URL + image"></v-img>
                    </v-col>
                  </v-row>
                </div>

              </v-col>

              <v-col cols="6">

                <v-alert color="info" text :icon="response.task.answer_type.icon" dense>
                  {{ response.task.answer_type.description.fr }}
                </v-alert>

                <div v-if="response.task.answer_type.key === 'multiple_images'">
                  <v-row>
                    <v-col cols="3" v-for="(image,imgIndex) in response.response?.data" :key="imgIndex">
                      <v-img v-if="image"
                             width="100%"
                             height="100%"
                             @click="showLightbox(imgIndex,response.response?.data)"
                             class="rounded-lg grey lighten-4 cursor-zoom"
                             :src="FILE_URL + image"></v-img>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="response.task.answer_type.key === 'image'">
                  <v-row>
                    <v-col cols="3">
                      <v-img width="100%"
                             height="100%"
                             @click="[lightboxImage = [{src: FILE_URL + response.response?.data}],visible = true]"
                             class="rounded-lg grey lighten-4 cursor-zoom"
                             :src="FILE_URL + response.response?.data"></v-img>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="response.task.answer_type.key === 'short_paragraph'
                 || response.task.answer_type.key === 'paragraph'
                 || response.task.answer_type.key === 'date'
                 || response.task.answer_type.key === 'time'">
                  <template v-if="/^(https?:\/\/|www\.)/i.test(response.response?.data)">
                    <a :href="response.response?.data.startsWith('http')? response.response?.data : 'https://' + response.response?.data"
                       target="_blank"
                       rel="noopener noreferrer"
                       class="text-primary"
                    >
                      {{ response.response?.data }}
                    </a>
                  </template>
                  <template v-else>
                    {{ response.response?.data }}
                  </template>
                </div>


                <div v-if="response.task.answer_type.key === 'file'">
                  <!--TODO-->
                </div>

                <div v-if="response.task.answer_type.key === 'audio'">
                  <!--TODO-->
                </div>

                <div v-if="response.task.answer_type.key === 'video'">
                  <!--TODO-->
                </div>

                <div v-if="response.task.answer_type.key === 'checkbox' || response.task.answer_type.key === 'radio'">


                  <div
                      v-for="(option, optionIndex) in response.task.task_question_options"
                      :key="optionIndex"
                      class="table-border pa-2 mb-1 rounded d-flex align-center justify-space-between"
                      @click="toggleAnswer(option.id,response)"
                      style="cursor: pointer"
                  >
                    {{ option.option?.option?.fr }}


                    <div v-if="response.task.answer_type.key === 'checkbox'">
                      <v-icon color="success" v-if="response.response?.data?.includes(option.id)">
                        mdi-checkbox-marked
                      </v-icon>
                      <v-icon v-else>
                        mdi-checkbox-blank-outline
                      </v-icon>
                    </div>


                    <div v-else-if="response.task.answer_type.key === 'radio'">
                      <v-icon color="success" v-if="response.response?.data === option.id">
                        mdi-radiobox-marked
                      </v-icon>
                      <v-icon v-else>
                        mdi-radiobox-blank
                      </v-icon>
                    </div>
                  </div>


                  <div class="text-end mt-3" v-if="status !== 'completed'">
                    <v-btn text class="v-btn--active" v-if="view !== 'dashboard'"
                           color="gifty"
                           block
                           :loading="isLoading"
                           @click="updateResponse(response.id,response.response?.data)">
                      <v-icon left>mdi-content-save</v-icon>
                      Valider les modifications
                    </v-btn>
                  </div>

                </div>

              </v-col>

            </v-row>
          </v-card-text>

        </v-card>

      </v-card-text>

    </v-card>

    <vue-easy-lightbox
                       :visible="visible"
                       :imgs="lightboxImage"
                       :index="index"
                       @hide="visible = false"></vue-easy-lightbox>

  </v-dialog>

</template>

<script>
import {HTTP} from "@/http-common";

export default {
  props: ["status", 'view'],
  emits: ["refresh"],
  data() {
    return {
      overlay: false,
      isLoading: false,
      btnLoading: false,
      is_required_skus: true,
      dialog: false,
      remark: null,
      investigation: {},
      errors: {},
      skus: [],

      /**Lightbox**/
      FILE_URL: process.env.VUE_APP_FILE_URL,
      lightboxImage: "",
      visible: false,
      index: 0,
    }
  },
  methods: {
    open(investigation) {

      this.errors = {}
      this.is_required_skus = true
      this.remark = investigation.remark ?? null
      this.investigation = investigation

      this.skus = this.investigation.investigation.skus.filter(
          sku => sku.selected
      )

      const responses = investigation.grading_rule_responses || []

      this.investigation.investigation.grading_rules =
          (investigation.investigation.grading_rules || []).map(rule => {
            const response = responses.find(
                r => r.grading_rule_id === rule.id
            )

            return {
              ...rule,
              status: response ? response.status : 'non_conform'
            }
          })

      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    save() {
      this.btnLoading = true
      HTTP.post('/v1/opus/backoffice/investigations/notation', {
        submission_id: this.investigation.id,
        grading_rules: this.investigation.investigation.grading_rules,
        is_required_skus: this.is_required_skus,
        skus: this.skus,
        remark: this.isValidated ? null : this.remark,
      }).then(() => {
        this.btnLoading = false
        this.$successMessage = "Opération réussi !"
        this.dialog = false
        this.$emit('refresh')
      }).catch(err => {
        this.btnLoading = false

        if (err.response && err.response.data.errors) {
          this.errors = err.response.data.errors
          this.scrollToTop()
        }

        console.log(err)
      })
    },

    scrollToTop() {
      this.$nextTick(() => {
        const el = document.querySelector('.dialog-scroll-target')
        if (el) el.scrollTo({ top: 0, behavior: 'smooth' })
      })
    },
    showLightbox(index, imgs) {
      if (imgs && imgs.length) {
        this.lightboxImage = imgs.map((img) => {
          return {src: this.FILE_URL + img}
        });
        this.index = index;
        this.visible = true;
      }
    },
    updateResponse(response_id, response) {
      this.isLoading = true
      HTTP.post('/v1/opus/backoffice/investigations/update-response', {
        response_id: response_id,
        response: response,
      }).then(() => {
        this.isLoading = false
        this.$successMessage = "Opération réussi !"
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },

    toggleAnswer(id, response) {
      if (response.task.answer_type.key === "checkbox") {
        if (!Array.isArray(response.response.data)) {
          response.response.data = []
        }
        const index = response.response.data.indexOf(id)
        index > -1
            ? response.response.data.splice(index, 1)
            : response.response.data.push(id)
      } else if (response.task.answer_type.key === "radio") {
        response.response.data = id
      }
    }

  },
  computed: {
    totalScore() {
      return (
          this.investigation?.investigation?.grading_rules ?? []
      ).reduce((total, rule) => {
        const note = Number(rule.note ?? 0)
        return total + (rule.status === 'conform' ? note : 0)
      }, 0)
    },
    isValidated() {
      const rules = this.investigation?.investigation?.grading_rules || [];
      return rules.some(rule => rule.award_points === 1 && rule.status === 'conform');
    }
  }
}
</script>

<style>
.bg-subtle-gifty {
  background-color: rgba(214, 12, 86, 0.15) !important;
}

.custom-chip .v-chip:not(.v-chip--active) {
  background: #d60c56 !important;
  color: white;
}

.custom-chip .v-chip:not(.v-chip--active) .mdi-close-circle {
  color: white;
}

.vel-img {
  max-width: none !important;
  height: auto !important;
}

.vel-modal img {
  max-width: none !important;
}

</style>